import React from "react";
import { Link } from "react-router-dom";
import { deletionFacts } from "./DeleteAccount";
import "./account.css";

/** Public page explaining how to delete a Technogenious account (website or app). */
export default function DeleteAccountInfo() {
  return <main className="account-page"><section className="account-card">
    <p className="account-eyebrow">TECHNOGENIOUS SOLUTIONS</p>
    <h1>Delete your account</h1>
    <p>You can delete your Technogenious account yourself, on the website or in the Technogenious app.</p>
    <h2>On the website</h2>
    <ol><li><Link to="/login">Sign in</Link> and open <Link to="/account">My account</Link>.</li><li>Choose <strong>Delete my account…</strong>, enter your password and confirm.</li></ol>
    <h2>In the app</h2>
    <ol><li>Open the <strong>Account</strong> tab and sign in.</li><li>Choose <strong>Delete my account</strong>, enter your password and confirm.</li></ol>
    <h2>Can’t sign in?</h2>
    <p>Email <a href="mailto:technogeniousja@gmail.com?subject=Account%20deletion%20request">technogeniousja@gmail.com</a> from the address on your account and ask us to delete it. We may ask you to confirm the request before acting on it.</p>
    <h2>What happens</h2>
    <ul>{deletionFacts.map(f => <li key={f}>{f}</li>)}</ul>
    <p>See our <Link to="/privacy-policy">privacy policy</Link> for more about how we handle your information.</p>
  </section></main>;
}
